import React, { useState, useEffect, useRef, useMemo } from "react";

import {
  Col,
  Row,
  Divider,
  Input,
  Form,
  Button,
  Card,
  InputNumber,
  Checkbox,
  Modal,
  Tooltip,
  notification,
  Select,
  DatePicker,
  Upload,
} from "antd";
import PhoneInput from "react-phone-input-2";
import {
  BarsOutlined,
  CopyOutlined,
  DownloadOutlined,
  SendOutlined,
  QuestionCircleOutlined,
  YoutubeFilled,
  InfoCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import CurrencyInput from "react-currency-input";
import RequestHandler from "util/RequestHandler";
import Screen from "../../util/Extensions/Screens";
import config from "../../util/ApiforContext";
import { odata } from "../Filters/Helper";
import Cleave from "cleave.js/react";
import { defaultValidateMessages } from "../Forms/Helper";
import { ColumnHelper } from "util/TableHelper";
import PosCommissionTable from "./PosCommissionTable";
import PosSelectableInstallmentTable from "./PosSelectableInstallmentTable";
import moment from "moment";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
};
const PaymentRequest = (props) => {
  const [form] = Form.useForm();
  const [copyUrl, setCopyUrl] = useState("");
  const [amount, setAmount] = useState("");
  const [paymentGuid, setPaymentGuid] = useState("");
  const [amountString, setAmountString] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [constantPhoneNumber, setConstantPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [constantEmail, setConstantEmail] = useState("");
  const [description, setDescription] = useState("");
  const [installmentCount, setInstallmentCount] = useState("");
  const [constFirmId, setConstFirmId] = useState();
  const [convertedMoney, setConvertedMoney] = useState("");
  const [constantUrl, setConstantUrl] = useState();
  const [readyDisable, setReadyDisable] = useState(false);
  const [mailReadyDisable, setMailReadyDisable] = useState(false);
  const [smsReadyDisable, setSmsReadyDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSms, setLoadingSms] = useState(false);
  const [constLoading, setConstLoading] = useState(false);
  const [loadingConstSms, setLoadingConstSms] = useState(false);
  const [constantLinkModalVisible, setConstantLinkModalVisible] =
    useState(false);
  const [currency, setCurrency] = useState(1);
  const [creditCardType, setCreditCardType] = useState("");
  const [readyConstDisable, setReadyConstDisable] = useState(false);
  const [paymentModal, setPaymentModal] = useState({
    visible: false,
    source: null,
  });
  const [firmsBalance, setFirmsBalance] = useState({
    loading: true,
    data: [],
  });
  const [activeFirmBalance, setActiveFirmBalance] = useState(0);
  const [availableInstallments, setAvailableInstallments] = useState({
    loading: false,
    data: [1],
  });
  const [activeProviderId, setActiveProviderId] = useState();
  const [activeFirmId, setActiveFirmId] = useState();
  const [currencyCodes, setCurrencyCodes] = useState(["TRY", "USD", "EUR"]);
  const [commissionOptions, setCommissionOptions] = useState({
    loading: true,
    data: {
      useCommissionsForAvailableInstallment: false,
      useFirmGroupCodeForMaxInstallment: false,
      isSelectableInstallmentTable: false,
      commissions: [],
      firmPaymentSetId: null,
    },
  });
  const [activeAmount, setActiveAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0.0);
  const [radioValue, setRadioValue] = useState();
  const iframeRef = useRef();

  const [availableProviders, setAvailableProviders] = useState({
    loading: true,
    data: [],
  });
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: false,
  });

  const [bankProviders, setBankProviders] = useState([]);

  const { Option } = Select;
  const [paymentSelect, setPaymentSelect] = useState({
    data: [],
    loading: false,
  });
  const [activePaymentSetId, setActivePaymentSetId] = useState(null);

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  const tailLayout = {
    wrapperCol: { offset: 8, span: 24 },
  };
  const [preAuthBankIds, setPreAuthBankIds] = useState([]);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    getAvailableProviders();
    getFirmsBalance();
    getCommissionOptions();
    getPaymentSets();
    getPreAuthBankIds();
  }, []);

  useEffect(() => {
    if (!activeProviderId) return;
    let currencies = ["TRY", "USD", "EUR"];

    //Param Pos
    if (activeProviderId === 889) {
      currencies = ["TRY"];
    }

    setCurrencyCodes(currencies);
    setFieldsValue({ currencyCode: currencies[0] });

    if (!commissionOptions.data.isSelectableInstallmentTable) {
      getAvailableInstallments(activeProviderId, activeFirmId);
    }
  }, [activeProviderId]);

  useEffect(() => {
    const firmId = activeFirmId === "clear" ? undefined : activeFirmId;

    if (!commissionOptions.data.isSelectableInstallmentTable) {
      getAvailableInstallments(activeProviderId, firmId);
    }
    //taksit tablosundan banka ve taksit seçmede bayi değişince seçimi sıfırlıyoruz.
    clearRadioValue();
    getCommissionOptions(firmId, activePaymentSetId);
  }, [activeFirmId]);

  useEffect(() => {
    if (props.data) {
      setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    changeCurrencyValue(activeAmount);
  }, [activeAmount]);

  useEffect(() => {
    getCommissionOptions(null, activePaymentSetId);
  }, [activePaymentSetId]);

  const getPaymentSets = () => {
    setPaymentSelect({ data: [], loading: true });

    RequestHandler.get(`/PaymentSet?$select=id,name`).then((res) => {
      let response = res.value;
      response.unshift({ id: null, name: "Varsayılan" });
      setPaymentSelect({ data: res.value, loading: false });
    });
  };

  const getAvailableProviders = () => {
    RequestHandler.get(`/PosCollection/AvailableProviders`).then((response) => {
      if (response.success) {
        setAvailableProviders({
          data: response.data,
          loading: false,
        });
        setBankProviders(response.data);
        setActiveProviderId(response.data?.at(0)?.id);
      } else {
        setAvailableProviders({ ...availableProviders, loading: false });
      }
    });
  };
  const phoneCantEmpty = (type) => {
    notification[type]({
      message: "HATA",
      description:
        "Telefon numarası alanı boş olduğu için sms gönderme işlemi tamamlanamadı.",
      duration: 4,
    });
  };
  const mailCantEmpty = (type) => {
    notification[type]({
      message: "HATA",
      description:
        "Email alanı boş olduğu için mail gönderme işlemi tamamlanamadı.",
      duration: 4,
    });
  };
  const phoneLength = (type) => {
    notification[type]({
      message: "HATA",
      description: "Telefon numarası formatı hatalı",
      duration: 4,
    });
  };
  const firmIdNull = (type) => {
    notification[type]({
      message: "HATA",
      description: "Firma seçimi yapmanız gerekmektedir.",
      duration: 4,
    });
  };
  const getCommissionOptions = (firmId, paymentSetId) => {
    let queryString = "";
    if (firmId) {
      queryString = "&firmId=" + firmId;
    }
    if (paymentSetId) {
      queryString += "&paymentSetId=" + paymentSetId;
    }
    RequestHandler.get(
      `/PosCollection/CommissionOptions?requestForNoPayment=true${queryString}`
    ).then((response) => {
      if (response.success) {
        setCommissionOptions({
          data: response.data,
          loading: false,
        });

        if (availableProviders.data.length > 0) {
          setAvailableProviders({
            data: bankProviders.filter((y) =>
              response.data.commissions.map((x) => x.bankId).includes(y.id)
            ),
            loading: false,
          });
        }
        if (firmId && response.data.firmPaymentSetId !== null) {
          setActivePaymentSetId(response.data.firmPaymentSetId);
        }
      } else {
        setCommissionOptions({ ...commissionOptions, loading: false });
      }
    });
  };

  const getFirmsBalance = () => {
    RequestHandler.get("/PosCollection/GetFirmsBalanceFromErp").then(
      (response) => {
        if (Array.isArray(response)) {
          setFirmsBalance({
            data: response,
            loading: false,
          });
        } else {
          setFirmsBalance({ ...firmsBalance, loading: false });
        }
      }
    );
  };

  const getAvailableInstallments = (bankId, firmId) => {
    setAvailableInstallments({ ...availableInstallments, loading: true });

    RequestHandler.post(
      `/PosCollection/AvailableInstallments`,
      { bankId, firmId },
      false
    ).then((response) => {
      if (!response.success) {
        setAvailableInstallments({ ...availableInstallments, loading: false });
        setFieldsValue({ installmentCount: 1 });
        return;
      }

      const { installments, defaultInstallment } = response.data;
      setAvailableInstallments({ data: installments, loading: false });

      setFieldsValue({ installmentCount: defaultInstallment });
    });
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ ...firmSelect, loading: true });

      RequestHandler.get(
        `/Firm/FirmDropdown?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  useEffect(() => {
    getCurrencies();
    getAvailableProviders();
  }, []);

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });

    RequestHandler.get(`/Currency?$select=id,code`).then((response) => {
      setCurrencySelect({
        data: response.value,
        loading: false,
      });
    });
  };

  const changeCurrencyValue = (value, currencyId) => {
    currencyId =
      currencyId == "TRY" || currencyId == undefined
        ? 1
        : currencyId == "USD"
        ? 2
        : 3;
    setActiveAmount(value);
    setAmount(value);

    // RequestHandler.post(
    //   `/PaymentRequest/GetCurrencyValue`,
    //   {
    //     amount: value === null || value === "" ? 0 : value,
    //     currencyId: currencyId === undefined ? currency : currencyId,
    //   },
    //   false
    // ).then((response) => {
    //   setConvertedMoney(response.message);
    // });
  };

  const QuestionMarkToolTip = ({ tooltip }) => {
    return (
      <Tooltip title={tooltip}>
        <QuestionCircleOutlined
          className="gx-text-blue"
          style={{ marginRight: 10, marginTop: 6, fontSize: "150%" }}
        />
      </Tooltip>
    );
  };

  const onFinish = (values) => {
    setAmountString(payableAmount);
    setPhoneNumber(values.PhoneNumber);
    setEmail(values.EMail);
    setDescription(values.Description);
    RequestHandler.post(
      `/PaymentRequest`,
      {
        CurrencyId: currency,
        AmountString: payableAmount,
        PhoneNumber: values.PhoneNumber,
        FirmId: values.firmId,
        EMail: values.EMail,
        Description: values.Description,
        cardType: values.cardType,
        paymentSetId: activePaymentSetId,
        validityDate: values.validityDate,
        isPreAuth: values.paymentType === "PREAUTH",
      },
      true
    ).then((response) => {
      if (response?.success) {
        setPaymentGuid(response.message);
        setCopyUrl(
          config.frontEndUrl + "PaymentPage?paymentGuid=" + response.message
        );

        if (values.EMail?.trim().length > 0) {
          setMailReadyDisable(true);
        }
        if (values.PhoneNumber?.trim().length > 0) {
          setSmsReadyDisable(true);
        }

        form.resetFields(["amount"]);
      }
    });
  };

  const sendMail = () => {
    if (email === null || email === undefined || email === "") {
      mailCantEmpty("error");
      return;
    }
    RequestHandler.post(
      `/PaymentRequest/SendMail`,
      {
        PaymentGuidString: paymentGuid,
        EMail: email,
        ScreenOption: Screen.screen,
      },
      true
    ).then((response) => {
      if (response?.success) {
        // setPaymentGuid(response);
        setMailReadyDisable(true);
        setLoading(false);
      }
    });
  };
  const sendConstMail = () => {
    setConstLoading(true);
    if (
      constantEmail === null ||
      constantEmail === undefined ||
      constantEmail === ""
    ) {
      setConstLoading(false);

      mailCantEmpty("error");
      return;
    }
    RequestHandler.post(
      `/ConstantPaymentRequest/SendMail`,
      {
        PaymentGuidString: constantUrl.split("d=")[1],
        EMail: constantEmail,
        ScreenOption: Screen.screen,
      },
      true
    ).then((response) => {
      if (response.success) {
        // setPaymentGuid(response);
        setReadyConstDisable(true);
        setConstLoading(false);
      }
    });
  };
  const sendConstSms = () => {
    if (
      constantPhoneNumber === null ||
      constantPhoneNumber === "" ||
      constantPhoneNumber === undefined
    ) {
      phoneCantEmpty("error");
      setTimeout(() => {
        setLoadingConstSms(false);
      }, 1000);
    } else if (constantPhoneNumber.length !== 12) {
      phoneLength("error");
      setTimeout(() => {
        setLoadingConstSms(false);
      }, 1000);
    } else {
      RequestHandler.post(
        `/ConstantPaymentRequest/SendSmsWithLink`,
        {
          PhoneNumber: constantPhoneNumber,
          Url: constantUrl,
        },
        true
      ).then((response) => {
        if (response.success) {
          setLoadingConstSms(false);
        }
      });
    }
  };
  const sendSms = () => {
    if (
      phoneNumber === null ||
      phoneNumber === "" ||
      phoneNumber === undefined
    ) {
      phoneCantEmpty("error");
      setTimeout(() => {
        setLoadingSms(false);
      }, 1000);
    } else if (phoneNumber.length !== 12) {
      phoneLength("error");
      setTimeout(() => {
        setLoadingSms(false);
      }, 1000);
    } else {
      RequestHandler.post(
        `/PaymentRequest/SendSmsWithLink`,
        {
          PhoneNumber: phoneNumber,
          Url: copyUrl,
        },
        true
      ).then((response) => {
        if (response?.success) {
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      });
    }
  };
  const onCurrencyChange = (value) => {
    let currencyId =
      value == "TRY" || value == undefined ? 1 : value == "USD" ? 2 : 3;
    setCurrency(currencyId);
    if (amount != null && amount != "" && amount != undefined) {
      changeCurrencyValue(amount, value);
    }
  };

  const onFinishFailed = () => {
    setLoading(false);
  };

  const disabledDate = (current) => {
    return current && current < moment().startOf("day");
  };
  const renderSelectableInstalmentCardInfoInputs = () => {
    return (
      <>
        <Col xs={24} lg={12} span={12}>
          <Form.Item label="Tutar" name="amount" rules={[{ required: true }]}>
            <InputNumber
              style={{ width: "100%" }}
              decimalSeparator=","
              precision={2}
              min={0}
              maxLength={15}
              placeholder="0,00"
              onChange={(value) => {
                const re = /^\d*\.?\d*$/;
                if (re.test(value)) {
                  setActiveAmount(value);
                }
              }}
            />
          </Form.Item>
        </Col>

        <Col xs={24} lg={12} span={12}>
          <Form.Item
            label="Para Birimi"
            name="currencyCode"
            initialValue={currencyCodes[0]}
          >
            <Select onChange={onCurrencyChange}>
              {currencyCodes.map((currencyCode) => (
                <Select.Option key={currencyCode} value={currencyCode}>
                  {currencyCode}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} lg={12} span={12}>
          <Form.Item name="paymentSetId" label="Ödeme Seti :">
            <Select
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={paymentSelect.loading}
              onChange={(value) => setActivePaymentSetId(value)}
              defaultValue={
                paymentSelect.data.length > 0
                  ? paymentSelect.data[0].id
                  : undefined
              }
            >
              {paymentSelect.data.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Geçerlilik Tarihi" name="validityDate">
            <DatePicker
              format="DD.MM.YYYY"
              style={{ width: "100%" }}
              disabledDate={disabledDate}
            />
          </Form.Item>
        </Col>

        {hasPreAuthBank && (
          <Col span={12}>
            <Form.Item
              name="paymentType"
              label={
                <span>
                  Ödeme Yöntemi&nbsp;
                  <Tooltip title="Ödeme esnasında seçilen Banka/Ödeme Kuruluşu'nun Provizyon entegrasyonu var ise, Provizyon işlemi yapılır.">
                    <InfoCircleOutlined style={{ color: "#1890ff" }} />
                  </Tooltip>
                </span>
              }
              initialValue="SALE"
            >
              <Select>
                <Select.Option value="SALE">Satış</Select.Option>
                <Select.Option value="PREAUTH">Provizyon</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        )}
        <Col span={24}>
          <PosSelectableInstallmentTable
            data={commissionOptions.data}
            amount={activeAmount}
            loading={commissionOptions.loading}
            onChange={onChangeRadio}
            radioValue={radioValue}
            disabledOptions={true}
          />
        </Col>
      </>
    );
  };

  const onChangeRadio = (radioVal, values) => {
    setRadioValue(radioVal);
    setFieldsValue(values);
  };

  const clearRadioValue = () => {
    setRadioValue(null);
    form.setFieldsValue({ bankIdInstallment: null });
  };

  const setFieldsValue = (values) => {
    const currentValues = form.getFieldsValue();
    const newValues = { ...currentValues, ...values };
    form.setFieldsValue(newValues);

    onFormValuesChange(values, newValues);
  };

  const onFormValuesChange = (changedValues, allValues) => {
    var activeCommissions = commissionOptions.data.commissions.find(
      (x) => x.bankId === allValues.bankId
    );
    if (allValues.bankIdInstallment) {
      var bankIdCommissionIdWithInstallment =
        allValues.bankIdInstallment.split("/");

      activeCommissions = commissionOptions.data.commissions.find(
        (x) =>
          x.bankId === allValues.bankId &&
          x.id === bankIdCommissionIdWithInstallment[1]
      );
    }

    if (!activeCommissions) {
      setPayableAmount(
        calculatePayableAmount(allValues.amount, 0, allValues.bankId, false)
      );
      return;
    }
    const commissionRate =
      activeCommissions["commissionRate" + allValues.installmentCount];
    if (!(allValues.amount > 0 && commissionRate >= 0)) {
      setPayableAmount(
        calculatePayableAmount(allValues.amount, 0, allValues.bankId, false)
      );
      return;
    }

    setPayableAmount(
      calculatePayableAmount(
        allValues.amount,
        commissionRate,
        allValues.bankId,
        activeCommissions["isCommissionFromDealer"]
      )
    );
  };

  const calculatePayableAmount = (
    amount,
    commissionRate,
    bankId,
    isCommissionFromDealer
  ) => {
    const { useCommissionsForAvailableInstallment } = commissionOptions.data;
    let payableAmount = amount;

    if (commissionRate === 0 && bankId === undefined) {
      return payableAmount;
    }
    if (useCommissionsForAvailableInstallment) {
      payableAmount = amount + (amount / 100) * commissionRate;
    }

    if (isCommissionFromDealer && useCommissionsForAvailableInstallment) {
      payableAmount = (amount / (100 - commissionRate)) * 100;
    }

    if (bankId == 856) {
      payableAmount = amount / ((100 - commissionRate) / 100);
    }

    return payableAmount;
  };
  const createConstUrl = () => {
    if (
      constFirmId === null ||
      constFirmId === "" ||
      constFirmId === undefined
    ) {
      firmIdNull("error");
    } else {
      RequestHandler.post(
        `/ConstantPaymentRequest`,
        {
          FirmId: constFirmId,
        },
        true
      ).then((response) => {
        if (response.success) {
          setConstantUrl(
            config.frontEndUrl +
              "ConstantPaymentPage?paymentGuid=" +
              response.message
          );
          setReadyConstDisable(true);
        }
      });
    }
  };

  const getPreAuthBankIds = () => {
    RequestHandler.get(
      `/Bank?&filter=isSupportPosPreAuth eq true&select= id`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setPreAuthBankIds(response.value.map((item) => item.id));
      }
    });
  };

  const hasPreAuthBank = useMemo(() => {
    if (!commissionOptions?.data?.commissions.length) return false;

    return commissionOptions.data.commissions.some((option) =>
      preAuthBankIds.includes(option.bankId)
    );
  }, [commissionOptions?.data]);

  const downloadExcelTemplate = () => {
    window.open(
      `${
        config.apiUrl
      }/PaymentRequest/DownloadExcelTemplate?t=${RequestHandler.getToken()}`
    );
  };

  const uploadExcelProps = {
    name: "excel",
    action: `${config.apiUrl}/PaymentRequest/ImportExcel`,
    headers: {
      Authorization: "bearer " + RequestHandler.getToken(),
      ScreenOption: Screen.screen,
    },
    accept: ".xlsx",
    maxCount: 1,
    onChange(info) {
      setFileList(info.fileList);
      const { response, status } = info.file;

      if (status !== "error" && status !== "done") return;
      if (!response) return;

      const notificationType = response.success ? "success" : "error";

      notification[notificationType]({
        message: response?.message,
        duration: 3,
      });
      if (response?.success) {
        downloadImportResult(info?.file?.response?.data);
      }
      onSuccess();
      setLoading(false);
    },
  };

  const downloadImportResult = (fileName) => {
    window.open(
      `${
        config.apiUrl
      }/PaymentRequest/DownloadImportResult?t=${RequestHandler.getToken()}&fileName=${fileName}`
    );
    setLoading(false);
  };

  const onSuccess = () => {
    form.resetFields();
    setFileList([]);
    if (props.onSuccess) props.onSuccess();
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> ÖDEME LİNKİ OLUŞTUR
          </p>
        </Col>

        <Col
          xs={24}
          md={6}
          lg={3}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <QuestionMarkToolTip
            tooltip={
              <>
                <p>
                  <strong>Sabit Link Oluşturulursa:</strong>
                  <ul>
                    <li>
                      Bu alandan oluşturulan link bayiye ait sabit bir link
                      olacaktır, tekrarlı kullanılabilecektir.
                    </li>
                  </ul>
                </p>
              </>
            }
          />

          <Button
            type="primary"
            onClick={() => {
              setConstantLinkModalVisible(true);
            }}
            style={{ marginBottom: 5, marginRight: 16 }}
          >
            Sabit Link Oluştur
          </Button>
        </Col>
        <Col xs={24} md={6} lg={5} style={{ textAlign: "-webkit-center" }}>
          <Button
            icon={<DownloadOutlined />}
            onClick={(() => setLoading(true), downloadExcelTemplate)}
            loading={loading}
            type="primary"
          >
            Excel Şablonu İndir
          </Button>
          <Upload {...uploadExcelProps} fileList={fileList}>
            <Button
              type="primary"
              icon={<UploadOutlined />}
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Excel ile Ekle
            </Button>
          </Upload>
        </Col>

        <Col xs={24} md={24} lg={24}>
          <Form
            {...layout}
            form={form}
            name="control-hooks"
            onFinish={onFinish}
            fields={[
              { name: "Currency", value: convertedMoney },
              { name: "payableAmount", value: payableAmount },
              { name: "paymentSetId", value: activePaymentSetId },
            ]}
          >
            <Row>
              <Col xs={24} md={12} lg={12}>
                <Card
                  style={{ marginTop: 16 }}
                  title="Ödeme Formu"
                  loading={
                    availableProviders.loading || commissionOptions.loading
                  }
                >
                  {availableProviders.data.length > 0 ? (
                    <Form
                      {...formItemLayout}
                      validateMessages={defaultValidateMessages}
                      form={form}
                      name="PaymentForm"
                      initialValues={{
                        remember: true,
                      }}
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                      labelAlign="left"
                      onValuesChange={onFormValuesChange}
                    >
                      <Row>
                        <Col span={24}>
                          <Form.Item label="Bayi" name="firmId">
                            <Select
                              allowClear
                              showSearch
                              placeholder="Seçiniz"
                              onSearch={onFirmSearch}
                              filterOption={(input, option) =>
                                option.children
                                  .toLocaleLowerCase("tr-TR")
                                  .indexOf(input.toLocaleLowerCase("tr-TR")) >=
                                  0 ||
                                option.code
                                  .toLocaleLowerCase("tr-TR")
                                  .indexOf(input.toLocaleLowerCase("tr-TR")) >=
                                  0
                              }
                              loading={firmSelect.loading}
                              onChange={(value, option) => {
                                setActiveFirmId(value ?? "clear");

                                const firm = firmsBalance.data.find(
                                  (x) => x.code === option?.code
                                );
                                const balance =
                                  firm?.balance > 0 ? firm.balance : 0;

                                if (balance > 0) {
                                  setActiveFirmBalance(balance);
                                  setFieldsValue({ amount: balance });
                                  setActiveAmount(balance);
                                }
                              }}
                            >
                              {firmSelect.data.map((item) => (
                                <Select.Option
                                  key={item.id}
                                  value={item.id}
                                  code={item.firmBranchNumber}
                                >
                                  {`${item.name} (${item.firmBranchNumber})`}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        {renderSelectableInstalmentCardInfoInputs()}
                      </Row>
                    </Form>
                  ) : (
                    "Firmanızın tanımlı bir ödeme sağlayıcısı bulunmuyor."
                  )}
                </Card>
              </Col>

              <Col xs={24} md={12} lg={12}>
                <Card
                  style={{ marginTop: 16 }}
                  type="inner"
                  title="İletişim Bilgileri"
                >
                  <Form.Item
                    label="Telefon Numarası"
                    name="PhoneNumber"
                    rules={[
                      {
                        min: 12,
                        message: "Telefon numarasını eksiksiz giriniz.",
                      },
                    ]}
                  >
                    <PhoneInput
                      // disabled={readyDisable}
                      onChange={(val) => {
                        setPhoneNumber(val);
                      }}
                      inputStyle={{ width: "100%" }}
                      country="tr"
                      masks={{ tr: "(...) ...-..-.." }}
                    />
                  </Form.Item>
                  {/* <Form.Item name="PhoneNumber" label="Telefon Numarası">
                        <Input placeholder="Telefon Numarası"/>
                    </Form.Item> */}
                  <Form.Item
                    name="EMail"
                    label="EMail"
                    rules={[
                      {
                        type: "email",
                        message: "Lütfen geçerli bir E-mail adresi giriniz.",
                      },
                    ]}
                  >
                    <Input placeholder="EMail" disabled={mailReadyDisable} />
                  </Form.Item>
                  <Form.Item name="Link" label="Link">
                    <Input.Group compact>
                      <Input
                        placeholder="Link"
                        onChange={(text) => {
                          setCopyUrl(text.target.value);
                        }}
                        style={{ width: "calc(100% - 36px)" }}
                        value={copyUrl}
                      />
                      <Tooltip title="Linki kopyala">
                        <Button
                          icon={<CopyOutlined />}
                          onClick={() => navigator.clipboard.writeText(copyUrl)}
                        />
                      </Tooltip>
                    </Input.Group>
                  </Form.Item>
                  <Form.Item
                    name="Description"
                    label="Açıklama"
                    style={{ marginTop: -16 }}
                  >
                    <Input placeholder="Açıklama" disabled={readyDisable} />
                  </Form.Item>
                </Card>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    marginRight: "50px",
                    flexWrap: "wrap",
                  }}
                >
                  <Form.Item
                    {...tailLayout}
                    style={{ flex: "1 1 auto", marginBottom: "10px" }}
                  >
                    <Button
                      type="primary"
                      disabled={readyDisable}
                      htmlType="submit"
                      icon={<DownloadOutlined />}
                      style={{ width: "100%" }}
                    >
                      Ödemeyi Hazırla
                    </Button>
                  </Form.Item>
                  <Form.Item
                    {...tailLayout}
                    style={{ flex: "1 1 auto", marginBottom: "10px" }}
                  >
                    <Button
                      type="primary"
                      onClick={() => {
                        sendMail();
                        setLoading(true);
                      }}
                      icon={<SendOutlined />}
                      loading={loading}
                      disabled={!mailReadyDisable}
                      style={{ width: "100%" }}
                    >
                      Mail ile Gönder
                    </Button>
                  </Form.Item>
                  <Form.Item
                    {...tailLayout}
                    style={{ flex: "1 1 auto", marginBottom: "10px" }}
                  >
                    <Button
                      type="primary"
                      onClick={() => {
                        sendSms();
                        setLoadingSms(true);
                      }}
                      icon={<SendOutlined />}
                      loading={loadingSms}
                      disabled={!smsReadyDisable}
                      style={{ width: "100%" }}
                    >
                      Sms ile Gönder
                    </Button>
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Modal
        id="constantLink"
        centered
        visible={constantLinkModalVisible}
        onOk={() => setConstantLinkModalVisible(false)}
        onCancel={() => setConstantLinkModalVisible(false)}
        title={"Sabit Link Oluştur"}
        footer={null}
      >
        <Input.Group compact>
          <Input
            placeholder="Link"
            onChange={(text) => {
              setConstantUrl(text.target.value);
            }}
            style={{ width: "calc(100% - 36px)" }}
            value={constantUrl}
          />
          <Tooltip title="Linki kopyala">
            <Button
              icon={<CopyOutlined />}
              onClick={() => navigator.clipboard.writeText(constantUrl)}
            />
          </Tooltip>
        </Input.Group>

        <Select
          allowClear
          showSearch
          style={{ width: "100%" }}
          placeholder="Bayi Seçiniz"
          onSearch={onFirmSearch}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
            option.code
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
          loading={firmSelect.loading}
          onChange={(value, option) => {
            setConstFirmId(value ?? "");
          }}
        >
          {firmSelect.data.map((item) => (
            <Select.Option
              key={item.id}
              value={item.id}
              code={item.firmBranchNumber}
            >
              {`${item.name} (${item.firmBranchNumber})`}
            </Select.Option>
          ))}
        </Select>
        <Row style={{ marginTop: 15 }}>
          <Col md={12}>
            <PhoneInput
              // disabled={readyDisable}
              onChange={(val) => {
                setConstantPhoneNumber(val);
              }}
              inputStyle={{ width: "100%" }}
              country="tr"
              masks={{ tr: "(...) ...-..-.." }}
            />
          </Col>
          <Col md={12}>
            <Input
              placeholder="EMail"
              value={constantEmail}
              onChange={(val) => setConstantEmail(val.target.value)}
            />
          </Col>
        </Row>

        <Row style={{ justifyContent: "space-evenly" }}>
          <Form.Item
            {...tailLayout}
            style={{ textAlign: "end", marginTop: 30 }}
          >
            <Button
              type="primary"
              onClick={() => {
                sendConstSms();
                setLoadingConstSms(true);
              }}
              icon={<SendOutlined />}
              loading={loadingConstSms}
              disabled={!readyConstDisable}
            >
              Sms ile Gönder
            </Button>
          </Form.Item>
          <Form.Item
            {...tailLayout}
            style={{ textAlign: "end", marginTop: 30 }}
          >
            <Button
              type="primary"
              onClick={() => {
                sendConstMail();
              }}
              icon={<SendOutlined />}
              loading={constLoading}
              disabled={!readyConstDisable}
            >
              Mail ile Gönder
            </Button>
          </Form.Item>

          <Form.Item
            {...tailLayout}
            style={{ textAlign: "end", marginTop: 30 }}
          >
            <Button
              type="primary"
              onClick={createConstUrl}
              icon={<DownloadOutlined />}
            >
              Linki Oluştur
            </Button>
          </Form.Item>
        </Row>
      </Modal>
    </>
  );
};
export default PaymentRequest;
